﻿import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router'
import { connect } from 'react-redux';
import {AgGridReact} from 'ag-grid-react';
import service from '../../services/feed-source-services';

class FeedSourceList extends Component {
    constructor(props, context) {
        super(props, context);

        this.addNewFeedSource = this.addNewFeedSource.bind(this);
        this.handleResize = this.handleResize.bind(this);

        const tableHeight = this.getTableHeight();
        this.state = {
            tableHeight
        };

        this.gridOptions = null;
    }

    componentDidMount() {
        const self = this;

        this.props.onGetFeedSources();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        const self = this;
        this.props.onUnload();
        window.removeEventListener('resize', this.handleResize);
    }

    getTableHeight(){
        return window.innerHeight - 64/*header*/ - 20;
    }

    handleResize(e) {
        setTimeout(() => {
            var tableHeight = this.getTableHeight();
            this.setState({tableHeight: tableHeight});

            if(this.gridOptions) {
                this.gridOptions.api.sizeColumnsToFit();
            }

        }, 200);
    }

    addNewFeedSource() {
        browserHistory.push('/feed-source/0');
    }

    onGridReady(options) {
        console.log(options);
        this.gridOptions = options;
        this.setGridData();
    }

    setGridData() {
        if(this.gridOptions && this.props && this.props.feedSources){
            this.gridOptions.api.setRowData(this.props.feedSources);
        }

        setTimeout(() => {
            if(this.gridOptions) {
                this.gridOptions.api.sizeColumnsToFit();
            }
        }, 200);
    }

    queuesColumns() {
        const self = this;
        const defWidth = 80;
        const columnDefs = [
            {
                headerName: "Id",
                field: "Id",
                headerTooltip: "Id",
                width: 60,
                pinned: true,
            },
            {
                headerName: 'Feed Type',
                width: 100,
                headerTooltip: "Feed Type",
                pinned: true,
                field: "FeedTypeName",
                cellStyle: {paddingTop: 0, textAlign: "left"},
            },
            {
                headerName: 'Source Id',
                width: 160,
                headerTooltip: "Source Id",
                pinned: true,
                field: "SourceId",
                cellStyle: {paddingTop: 0, textAlign: "left"},
            },
            {
                headerName: 'Name',
                width: 160,
                headerTooltip: "Name",
                pinned: true,
                field: "Name",
                cellStyle: {paddingTop: 0, textAlign: "left"},
            },
            {
                headerName: 'Link',
                headerTooltip: "Link",
                pinned: true,
                field: "Link",
                cellStyle: {paddingTop: 0, textAlign: "left"},
            },
            {
                headerName: 'Min Listeners',
                headerTooltip: "Min Listeners",
                pinned: true,
                field: "MinListeners",
                cellStyle: {paddingTop: 0, textAlign: "left"},
            }
        ];
        return columnDefs;
    }

    onRowSelected() {
        const selectedRow = this.gridOptions.api.getSelectedRows()[0];

        if(selectedRow){
            browserHistory.push(`/feed-source/${selectedRow.Id}`);
        }
    }

    render() {
        console.log('render feed source list');
        const { feedSources } = this.props;
        this.setGridData();
        return (
            <div ref="mainComponent" className="ag-material" style={{width: "100%", margin: "auto", height: this.state.tableHeight + "px"}}>
                <AgGridReact
                    colWidth={120}
                    minColWidth={50}
                    onGridReady={this.onGridReady.bind(this)}
                    columnDefs={this.queuesColumns()}
                    onSelectionChanged={this.onRowSelected.bind(this)}
                    rowSelection="single"
                    enableSorting="true"
                    enableFilter="true"
                    enableColResize="true"
                />
            </div>
        );
    }
}

FeedSourceList.contextTypes = {
    router: PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.feedSources});

const mapDispatchToProps = dispatch => ({
    onGetFeedSources: () =>
        dispatch({type: 'REQUEST_FEED_SOURCES', payload: service.FeedSourceServices.getFeedSources()}),
    onUnload: () =>
        dispatch({type: 'FEED_SOURCES_PAGE_UNLOADED'})
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedSourceList);